import { ListItemsSkeletonComponent } from './list-items-skeleton.component';

export default angular
  .module('sfMobile.components.list-items-skeleton', [
    'sfMobile.components.item-skeleton',
    'sfMobile.components.item-avatar-skeleton',
  ])
  .component('sfListItemsSkeleton', ListItemsSkeletonComponent).name;
